const initialState = {
  projects: [],
  loading: false,
  error: null,
  pageCount: 0,
  total: 0,
  stats: null,
  currentProject: null,
  currentLoading: false,
  createLoading: false,
  updateLoading: false,
  // Bumped after any project/action mutation → list & stats refetch.
  version: 0,
};

const appProjectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PROJECTS_LOADING":
      return { ...state, loading: true, error: null };
    case "FETCH_PROJECTS_SUCCESS":
      return {
        ...state,
        loading: false,
        projects: action.payload?.data ?? [],
        pageCount: action.payload?.meta?.pagination?.pageCount ?? 0,
        total: action.payload?.meta?.pagination?.total ?? 0,
      };
    case "FETCH_PROJECTS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        projects: [...state.projects, ...(action.payload?.data ?? [])],
        pageCount: action.payload?.meta?.pagination?.pageCount ?? 0,
        total: action.payload?.meta?.pagination?.total ?? 0,
      };
    case "FETCH_PROJECTS_ERROR":
      return { ...state, loading: false, error: action.payload };

    case "FETCH_PROJECT_STATS_SUCCESS":
      return { ...state, stats: action.payload };

    case "FETCH_CURRENT_PROJECT_LOADING":
      return { ...state, currentLoading: true };
    case "FETCH_CURRENT_PROJECT_SUCCESS":
      return {
        ...state,
        currentLoading: false,
        currentProject: action.payload,
        projects: state.projects.map((project) =>
          project.id === action.payload?.id ? action.payload : project
        ),
      };
    case "FETCH_CURRENT_PROJECT_ERROR":
      return { ...state, currentLoading: false };

    case "CREATE_PROJECT_LOADING":
      return { ...state, createLoading: true };
    case "CREATE_PROJECT_SUCCESS":
      return {
        ...state,
        createLoading: false,
        currentProject: action.payload,
        projects: [action.payload, ...state.projects],
        version: state.version + 1,
      };
    case "CREATE_PROJECT_ERROR":
      return { ...state, createLoading: false };

    case "UPDATE_PROJECT_LOADING":
      return { ...state, updateLoading: true };
    case "UPDATE_PROJECT_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        currentProject: action.payload,
        projects: state.projects.map((project) =>
          project.id === action.payload?.id ? action.payload : project
        ),
        version: state.version + 1,
      };
    case "UPDATE_PROJECT_ERROR":
      return { ...state, updateLoading: false };

    case "PROJECTS_TOUCHED":
      return { ...state, version: state.version + 1 };

    default:
      return state;
  }
};

export default appProjectsReducer;
